type BlogCardSkeletonProps = {
  amount?: number;
};

const BlogCardSkeleton = ({ amount = 4 }: BlogCardSkeletonProps) => {
  const skeletonCards = [];

  for (let i = 0; i < amount; i++) {
    skeletonCards.push(
      <div className="skeleton-blog-card" key={i}>
        <div className="skeleton-blog-card-image"></div>
        <div className="skeleton-blog-card-tag"></div>
        <div className="skeleton-blog-card-title"></div>
        <div className="skeleton-blog-card-desc"></div>
        <style jsx>
          {`
            @keyframes load {
              from {
                left: -150px;
              }
              to {
                left: 100%;
              }
            }

            .skeleton-blog-card {
              width: 32rem;
              max-width: 35vw;
              margin: 0 12px 24px;
              display: flex;
              align-content: center;
              flex-direction: column;
              align-items: flex-start;
              overflow: hidden;
              position: relative;
            }
            .skeleton-blog-card::before {
              content: "";
              display: block;
              position: absolute;
              left: -150px;
              top: 0;
              min-height: 450px;
              width: calc(35vw - 24px);
              background: -webkit-gradient(
                linear,
                left top,
                right top,
                from(transparent),
                color-stop(rgba(255, 255, 255, 0.3)),
                to(transparent)
              );

              background: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.3),
                transparent
              );
              animation: load 1s infinite;
            }
            .skeleton-blog-card-image {
              border-radius: 8px;
              width: 100%;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;
              background-color: #d8d8d8;
              min-height: 206.63px;
            }

            .skeleton-blog-card-tag {
              border-radius: 8px;
              width: 30px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;
              background-color: #d8d8d8;
              min-height: 15px;
              margin-top: 6px;
            }
            .skeleton-blog-card-title {
              border-radius: 8px;
              width: 100%;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;
              background-color: #d8d8d8;
              min-height: 30px;
              margin-top: 6px;
            }
            .skeleton-blog-card-desc {
              border-radius: 8px;
              width: 100%;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;
              background-color: #d8d8d8;
              min-height: 60px;
              margin-top: 6px;
            }
            @media only screen and (max-width: 730px) {
              .skeleton-blog-card {
                width: calc(100vw - 24px);
                max-width: 100%;
              }
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <>
      {skeletonCards}
      <style jsx>
        {`
          .skeleton-blog-card {
            width: calc(50% - 24px);
            margin: 0 12px 18px;
            display: flex;
            align-content: center;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
          }
        `}
      </style>
    </>
  );
};

export default BlogCardSkeleton;
